import {BaseWrapper} from './BaseWrapper';
import {BasicCriteria} from './BasicCriteria';
import {BasicEntity} from '../message/BasicEntity';
import {BasicScenario} from './BasicScenario';

export class BasicWrapper extends BaseWrapper<BasicEntity, BasicCriteria, BasicScenario>  {}

